<ion-grid class="ion-no-margin ion-no-padding">
  <ion-row class="ion-align-items-center">
    <ion-col size="2">
      <ion-avatar class="fixed-avatar">
        <img
          [src]="backendUrl | secure:'../../assets/images/anonymous.svg' | async"
          class="admia-person-avatar-top" />
      </ion-avatar>
    </ion-col>
    <ion-col size="10" class="username-elipsis">
      <ion-button
        *ngIf="personName !== '' && personName"
        size="small" fill="clear"
        class="ion-no-margin">
        <ion-label *ngIf="personName !== ''"
          class="line-height-1">
          {{ personName }}
        </ion-label>
    </ion-button>
    <ion-row>
      <ion-col class="username-elipsis linked-user-col">
          <ion-icon
            *ngIf="personName && personName !== ''"
            name="link-outline">
          </ion-icon>
          <ion-label *ngIf="userName !== ''"
            class="line-height-1 linked-user-label">
            {{ userName }}
          </ion-label>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-grid>
